import React, {useState} from 'react'
import ProductList from '../data/StoreData.json'
import ProductItem from './ProductItem'
import IntroSections from '../IntroSections'
import Pagination from './Pagination'



const Store = () => {
    const [currentPages, setcurrentPages] = useState(1);

//pagination 
  const product_in_page = 15
  const pages = Math.ceil(ProductList.length / product_in_page)

  const finishIndex = currentPages * product_in_page
  const startIndex = finishIndex - product_in_page;


  // filters
  const [query, setquery] = useState("");

  const [data, setdata] = useState(ProductList);

  const pagination = data.slice(startIndex, finishIndex)

  const filterbycat = (cattitem) => {
    const result = ProductList.filter((product) => {
      return product.categories === cattitem;
    })
      setdata(result);
  }


  


  return (
    <div className='Store '>
      <IntroSections sectionName="Store"sectionLink="Store" />
      <div className='container'>    
  <div className='row mt-5'>

          <div className='col-lg-3 mb-5'>
            <form className='filters'>

                <h4>Search</h4>
                <input type='text' placeholder='Search' onChange={(e)=>setquery(e.target.value)} />


              <div className='filterbyCAtt'>
              <h4>Filter By Categories</h4>
                <h6 className='d-block' onClick={() => filterbycat("Men")} >Men </h6>
                <h6 className='d-block' onClick={() => filterbycat("Women")} > Women </h6>
              <h6 className='d-block' onClick={() => filterbycat("KIDS")} > Kids </h6>  
              <h6 className='d-block' onClick={() => filterbycat("Accessories")} > Accessories </h6>
              <h6 className='d-block' onClick={()=>setdata(ProductList)} > All </h6>

             </div>
              



              </form>
          </div>

      <div className='col-lg-9'>
            <div className='row'>
      { 
                pagination.filter((item) => {
                  return (
                    item.title.toLowerCase().includes(query)
                    
                    )
                }).map((item) => {            
            return(      
            <div className='col-lg-4 col-md-6 ' key={item.id}>
                <ProductItem {...item } />
                
            </div>
      )
            })
              }

  <Pagination pages={pages}  currentPages={currentPages} setcurrentPages={setcurrentPages} />
           
        </div>
          
          
      </div>
  </div>
        




        </div>
      </div>
    )
}
        
export default Store